export default __webpack_public_path__ + "static/media/avax_logo.d567c107.svg";